<script setup lang="ts">
import { VueQueryDevtools } from '@tanstack/vue-query-devtools'

const isDev = import.meta.env.DEV
</script>

<template>
  <router-view v-slot="{ Component }">
    <transition name="fade">
      <component :is="Component" />
    </transition>
  </router-view>
  <VueQueryDevtools v-if="isDev" />
</template>

<style scoped></style>
